import Vue from 'vue'
import VueRouter from 'vue-router'
import DataServer from '../views/DataServer.vue'
// import SuCai from '../views/SuCai.vue'
// import FindDifference from '../views/FindDifference.vue'
// import Nonogram from '../views/Nonogram.vue'
// import DiceJigsaw from '../views/DiceJigsaw.vue'
// import AppMeta from '../views/AppMeta.vue'
import Login from '../views/Login.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'DataServer',
    component: DataServer
  },
  // {
  //   path: '/sucai',
  //   name: 'SuCai',
  //   component: SuCai
  // },
  // {
  //   path: '/finddifference',
  //   name: 'FindDifference',
  //   component: FindDifference
  // },
  {
    path: '/login',
    name: "login",
    component: Login
  }
  // {
  //   path: '/nonogram',
  //   name: 'nonogram',
  //   component: Nonogram,
  // },
  // {
  //   path: '/dicejigsaw',
  //   name: 'dicejigsaw',
  //   component: DiceJigsaw,
  // },
  // {
  //   path: '/appmeta',
  //   name: 'appmeta',
  //   component: AppMeta,
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
